import * as React from 'react';
import { RouteComponentProps, useHistory } from 'react-router';
import { Loader, Tabs } from '@teamsnap/teamsnap-ui';

// Local imports
import RegistrationForm from '../registration/v2/Registration';
import RegistrationList, { FormRetiredStatus } from '../registration/RegistrationList';
import NewFormButton from '../registration/NewFormButton';
import { useShowOrganization } from 'hooks/GraphQL';

type RouteParams = { orgId: string; formId: string };

const Registration: React.FC<RouteComponentProps<RouteParams>> = ({
  match: {
    params: { orgId, formId },
  },
}) => {
  const { useState } = React;

  const [isModalOpen, setIsModalOpen] = useState<boolean>(!!formId);

  const history = useHistory();
  const [prevPath, setPrevPath] = useState<string>(null);

  if (!prevPath && history.location.state && history.location.state['prevPath']) {
    setPrevPath(history.location.state['prevPath']);
  }

  const [data, , loading] = useShowOrganization(+orgId);

  if (loading) {
    return <Loader type="spin" text="Loading..." />;
  }

  const tabs = [
    {
      heading: 'Active',
      content: (
        <RegistrationList
          setIsModalOpen={setIsModalOpen}
          orgId={+orgId}
          orgName={data?.showOrganization?.name}
          retiredStatus={FormRetiredStatus.Active}
        />
      ),
    },
    {
      heading: 'Retired',
      content: (
        <RegistrationList
          setIsModalOpen={setIsModalOpen}
          orgId={+orgId}
          orgName={data?.showOrganization?.name}
          retiredStatus={FormRetiredStatus.Retired}
        />
      ),
    },
  ];

  return (
    <div id="programs" className="container hub-full-width">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1 data-testid="registration-heading">Registration</h1>
          </div>

          <NewFormButton
            orgId={+orgId}
            orgRegtype={data?.showOrganization?.registrationType}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
          />
        </div>

        <div className="page-content-body">
          <Tabs tabs={tabs} />
        </div>
        <RegistrationForm
          orgId={parseInt(orgId)}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          prevPath={prevPath}
          org={data?.showOrganization}
        />
      </div>
    </div>
  );
};

export default Registration;
